import { ICPServiceOtherType1 } from "@/types/global";
import ServiceAreaOtherCard from "./service-area-other-card";


const ServiceAreaOther = ({ title, description, data }: { title: string, description?: string, data: ICPServiceOtherType1[] }) => {
    return (
        <>
            <section
                className="desilo-service6-section section-padding-top overflow-hidden"
                id="service-section"
            >
                <div className="container custom-container">
                    <div className="row gx-4 gy-5">
                        <div className="col-12 col-xl-5 col-xxl-6">
                            <div className="desilo__header text-left text-lg-start">
                                <h2 className="title">
                                    {title}
                                </h2>
                                <p className="hero2-content-text">
                                    {description && description}
                                </p>
                            </div>
                        </div>
                        <div className="col-12 row-padding-top mt-0">
                            <div className="row g-4">
                                {/* service card start */}
                                {data?.map((item, i) => (
                                    <ServiceAreaOtherCard
                                        key={i}
                                        data={item}
                                    />
                                ))}
                                {/* service card end */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ServiceAreaOther;
